import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SX_STYLES } from 'libs/constants';
import { Layout, PrimaryHeader, PrimaryFooter, Divider } from 'components';
import { useMediaQuery } from '@mui/material';
import useTheme from '@mui/system/useTheme';
import { useLazyGetOfferQuery } from 'store/api';
import { AuthSession } from 'hooks/useAuth';
import Tracking from 'libs/tracking';
import Script from 'next/script';
import {
  Hero,
  FAQ,
  Mentioned,
  Testimonials,
  WhyKeen,
  Advisors,
  ExploreAdvisorCategories,
  MoreAdvisors
} from './@components';
import { HeaderBanner, HeaderHeroWrapper } from './styled';

const headerBgDesktop = 'https://si.keen.com/d1_hero-hp-side-d_V7.jpg';
const headerBgMobile = 'https://si.keen.com/d1_hero-hp-side-m_V7.jpg';

function HomePageSEO() {
  return (
    <Script
      id="home-page-seo-script"
      strategy="afterInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
          {
		        "@context" : "http://schema.org",
		        "@type" : "Organization",
		        "name" : "Keen",
		        "url" : "https://www.keen.com/",
		        "telephone" : "1-877-533-6435",
		        "logo": "https://scontent-ort2-2.xx.fbcdn.net/v/t1.0-0/p200x200/22780335_2041156639231696_8104054498829109453_n.png?_nc_cat=106&_nc_ht=scontent-ort2-2.xx&oh=696684fbf59730602007826a299963da&oe=5D213E02",
		        "sameAs" : [ "https://www.facebook.com/KeenPsychics/","https://www.instagram.com/keenpsychics/" ] 
          }
        `
      }}
    />
  );
}

function Home(): JSX.Element {
  const [offer, setOffer] = useState<OfferBanner>(null);
  const auth = AuthSession();
  const [getOffer] = useLazyGetOfferQuery();
  let userId = 0;
  if (auth.user && auth.user.id) userId = parseInt(auth.user.id, 10);
  const theme = useTheme();
  useEffect(() => {
    (async () => {
      if (auth.isAuthenticated === undefined) return;
      const { data: offerBannerInfo } = await getOffer(userId);
      setOffer(offerBannerInfo);
    })();
  }, [userId, getOffer, setOffer, auth.isAuthenticated]);
  return (
    <Layout>
      {offer && offer.TinyDescription && (
        <HeaderBanner>{offer.TinyDescription}</HeaderBanner>
      )}
      <Box display={{ md: 'none', xs: 'inherit' }}>
        <PrimaryHeader trackMixpanelEvent={Tracking.track} />
      </Box>
      <HeaderHeroWrapper
        backgroundimageurl={{
          desktop: headerBgDesktop,
          mobile: headerBgMobile
        }}>
        <Box style={{ width: '100%' }} display={{ md: 'inherit', xs: 'none' }}>
          <PrimaryHeader trackMixpanelEvent={Tracking.track} />
        </Box>
        <Hero />
      </HeaderHeroWrapper>
      <Container
        sx={{
          maxWidth: SX_STYLES.maxWidth,
          paddingRight: { lg: '10px' },
          paddingLeft: { lg: '10px' }
        }}>
        <Advisors />
        <MoreAdvisors />
        <Divider sizePx={useMediaQuery(theme.breakpoints.up('sm')) ? 50 : 30} />
        <Mentioned />
        <ExploreAdvisorCategories />
        <FAQ />
      </Container>
      <Testimonials />
      <WhyKeen />
      <PrimaryFooter />
      <HomePageSEO />
    </Layout>
  );
}

export default Home;
